import Auth from "./js/auth";
import Vue from "vue";
import Router from "vue-router";
import AdoAdmin from "./views/ado/Admin.vue";
import AdoAdminAssignment from "./views/ado/Assignment.vue";
import AdoAdminDashboard from "./views/ado/Dashboard.vue";
import AdoAdminExport from "./views/ado/Export.vue";
import AdoAdminHistory from "./views/ado/History.vue";
import AdoAdminSettings from "./views/ado/Settings.vue";
import AdoAdminSettingsCounsellors from "./views/ado/Settings/Counsellors.vue";
import AdoAdminSettingsNotifications from "./views/ado/Settings/Notifications.vue";
import AdoAdminSettingsCheckinOptions from "./views/ado/Settings/CheckinOptions.vue";
import AdoAdminSettingsWaitingAreas from "./views/ado/Settings/WaitingAreas.vue";
import AdoAdminSummary from "./views/ado/Summary.vue";
import AdoKiosk from "./views/ado/Kiosk.vue";
import QueueItemAdd from "./components/Queue/QueueItemAdd.vue";
import QueueItemEdit from "./components/Queue/QueueItemEdit.vue";
import StudentApp from "./views/student/App.vue";
import StudentHome from "./views/student/Home.vue";
import Unauthenticated from "./views/unauthenticated/Unauthenticated.vue";
import Unauthorized from "./views/unauthorized/Unauthorized.vue";

Vue.use(Router);

const routes = [{
    path: "*",
    beforeEnter: redirect
  },
  {
    path: "/ado/admin",
    component: AdoAdmin,
    children: [{
        path: '',
        component: AdoAdminDashboard
      },
      {
        path: 'assignment',
        component: AdoAdminAssignment
      },
      {
        path: 'export',
        component: AdoAdminExport
      },
      {
        path: 'history',
        component: AdoAdminHistory
      },
      {
        path: 'settings',
        component: AdoAdminSettings,
        children: [{
            path: 'checkin-options',
            component: AdoAdminSettingsCheckinOptions
          },
          {
            path: 'counsellors',
            component: AdoAdminSettingsCounsellors
          },
          {
            path: 'notifications',
            component: AdoAdminSettingsNotifications
          },
          {
            path: 'waiting-areas',
            component: AdoAdminSettingsWaitingAreas
          }
        ]
      },
      {
        path: 'summary',
        component: AdoAdminSummary
      },
      {
        path: 'queue/add',
        name: 'queue-add',
        component: QueueItemAdd
      },
      {
        path: 'queue/edit',
        name: 'queue-edit',
        component: QueueItemEdit,
        props: true
      }
    ],
    beforeEnter: validateAdminAccess
  },
  {
    path: "/student",
    component: StudentApp,
    children: [{
      path: '',
      component: StudentHome
    }],
    beforeEnter: validateStudentAccess
  },
  {
    path: "/ado/kiosk",
    name: "ado-kiosk",
    component: AdoKiosk,
    beforeEnter: validateAdminAccess
  },
  {
    path: "/unauthenticated",
    name: "unauthenticated",
    component: Unauthenticated,
    beforeEnter: checkAuthentication
  },
  {
    path: "/unauthenticated/:dropinstatus",
    name: "unauthenticated",
    component: Unauthenticated,
    props: true,
    beforeEnter: checkAuthentication
  },
  {
    path: "/unauthorized",
    name: "unauthorized",
    component: Unauthorized,
    beforeEnter: checkAuthorization
  }
];

function checkAuthentication(to, from, next) {
  // Check for authentication
  Auth.authorized().then(function (response) {
    if (response) {
      const user = Auth.getUser() || {};
      let dept = user.departmentShort || "";
      let department = user.department || "";
      let type = user.sessionType || "";

      // ITS root group override
      dept = dept.match(/its/i) ? 'ado' : dept;

      // Resolve user session type
      type = type.match(/(user)|(admin)/i) ? 'admin' : type;

      // Validate path route and authentication
      let path = routes.find(function (element) {
        return element.path.match(dept) && element.path.match(type);
      });

      // Resolve path redirect
      if (path && department != "student") {
        // Admin redirect
        next({
          path: `/${dept}/${type}`
        })
      } else if (department == "student" || type == "student") {
        // Student redirect
        next({
          path: `/student`
        })
      } else if (!path && type) {
        // Unauthorized redirect
        next({
          path: `/unauthorized`
        })
      } else {
        // Unauthenticated
        next();
      }
    } else {
      // Unauthenticated
      next();
    }
  }).catch(function () {
    // Unauthenticated
    next();
  })
}

function checkAuthorization(to, from, next) {
  // Check for authentication
  Auth.authorized().then(function (response) {
    if (response) {
      const user = Auth.getUser() || {};
      let dept = user.departmentShort || "";
      let department = user.department || "";
      let type = user.sessionType || "";

      // ITS root group override
      dept = dept.match(/its/i) ? 'ado' : dept;

      // Resolve user session type
      type = type.match(/(user)|(admin)/i) ? 'admin' : type;

      // Validate path route and authentication
      let path = routes.find(function (element) {
        return element.path.match(dept) && element.path.match(type);
      });

      // Resolve path redirect
      if (path && department != "student") {
        // Admin redirect
        next({
          path: `/${dept}/${type}`
        })
      } else if (department == "student" || type == "student") {
        // Student redirect
        next({
          path: `/student`
        })
      } else {
        // Unauthorized
        next();
      }
    } else {
      // Unauthenticated redirect
      next({
        path: `/unauthenticated`
      })
    }
  }).catch(function () {
    // Unauthenticated redirect
    next({
      path: `/unauthenticated`
    })
  })
}

function validateAdminAccess(to, from, next) {
  // Check for authentication
  Auth.authorized().then(function () {
    const user = Auth.getUser() || {};
    let dept = user.departmentShort || "";
    // let department = user.department || "";
    let type = user.sessionType || "";

    // ITS root group override
    dept = dept.match(/its/i) ? 'ado' : dept;

    // Resolve user session type
    type = type.match(/(user)|(admin)/i) ? 'admin' : type;

    // Resolve path redirect
    if (to.path.match(dept) && to.path.match(type)) {
      // Resolved route
      next();
    } else {
      // Unauthorized access
      next({
        path: `/unauthorized`
      })
    }
  }).catch(function () {
    // Unauthorized access
    next({
      path: `/unauthorized`
    })
  })
}

function validateStudentAccess(to, from, next) {
  // Check for authentication
  Auth.authorized().then(function () {
    const user = Auth.getUser() || {};
    let department = user.department || "";
    let type = user.sessionType || "";

    // Resolve path redirect
    if (department == "student" || type == "student") {
      // Resolved route
      next();
    } else {
      // Unauthorized access
      next({
        path: `/unauthorized`
      })
    }
  }).catch(function () {
    // Unauthorized access
    next({
      path: `/unauthorized`
    })
  })
}

function redirect(to, from, next) {
  // Redirect all unresolved path to unauthenticated
  next({
    path: `/unauthenticated`
  })
}

export default new Router({
  routes: routes
});